const PLACE_CXML_ORDER = 'PLACE_CXML_ORDER';

export { PLACE_CXML_ORDER };
